import { StatusRegisterEnum } from "@/main/services/enum/StatusRegisterEnum";
import { AssociatedBodyShopResponse } from "@/main/models/response/supplierResponse";

export interface IAssociatedBodyShopTrigger {
	loadedStatusKey: number | null;
	loadedRegistrationNumber: string;
	newStatusKey: number;
	newRegistrationNumber: string;
}

export function shouldCheckAssociatedBodyShops(trigger: IAssociatedBodyShopTrigger): boolean {
	const wasActive = trigger.loadedStatusKey === StatusRegisterEnum.Active;
	const leavesActive = trigger.newStatusKey !== StatusRegisterEnum.Active;
	const registrationNumberChanged = trigger.loadedRegistrationNumber !== trigger.newRegistrationNumber;

	return wasActive && (leavesActive || registrationNumberChanged);
}

export interface IExitConfirmationDependencies {
	fetchAssociatedBodyShops: () => Promise<AssociatedBodyShopResponse[]>;
	confirm: (bodyShops: AssociatedBodyShopResponse[]) => Promise<boolean>;
}

export async function evaluateSupplierExitConfirmation(
	trigger: IAssociatedBodyShopTrigger,
	dependencies: IExitConfirmationDependencies,
): Promise<boolean> {
	if (!shouldCheckAssociatedBodyShops(trigger)) return true;

	const associatedBodyShops = await dependencies.fetchAssociatedBodyShops();
	if (associatedBodyShops.length === 0) return true;

	return dependencies.confirm(associatedBodyShops);
}

export function joinAssociatedBodyShopNames(bodyShops: AssociatedBodyShopResponse[]): string {
	return bodyShops.map((bodyShop) => bodyShop.name).join(", ");
}

export function fillAssociatedBodyShopMessage(template: string, bodyShops: AssociatedBodyShopResponse[]): string {
	return template.replace("{0}", joinAssociatedBodyShopNames(bodyShops));
}
